import { MenuListTheme } from "@acin.reactjs/acin-ui/menuList";
import { DefaultTheme } from "styled-components";
import { PartialDeep } from "type-fest";
import { AppMediaQueries } from "./BreakpointsTheme";
import { fontFamilyRubik } from "./TypographyTheme";

const menuListTheme = (theme: DefaultTheme): PartialDeep<MenuListTheme> => ({
  root: {
    margin: "4px 0",
  },
  item: {
    label: {
      fontFamily: fontFamilyRubik,
      fontWeight: 300,

      [AppMediaQueries.maxMobile]: { fontSize: "14px", fontWeight: 400 },
    },
    divider: {
      backgroundColor: theme.palette.greys[200],
      border: 0,
      height: "1px",

      [AppMediaQueries.maxMobile]: {
        backgroundColor: theme.palette.greys[100],
      },
    },
  },
});

export default menuListTheme;
